import VueNativeSock from 'vue-native-websocket-vue3';
import { App } from 'vue';
import { useWebSocketStore } from '@/stores/webSocket';
import { getWebSocketURL } from '@/helpers';

export function registerWebSocket(app: App) {
    const store = useWebSocketStore();

    app.use(VueNativeSock, getWebSocketURL(''), {
        connectManually: true,
        reconnection: true,
        format: 'json',
        store,
    });
}
